<div class="dasboard-width">
    <div class="row header mar-lft-rgt-0">

        <div class="col-md-3 col-sm-2">Maintain Asset</div>
        <div class="col-md-3 col-sm-3">
            <input type="text" class="form-control radius-0 font-13" [(ngModel)]="assetValue"
                   placeholder="Digital Asset Id">
        </div>
        <div class="col-md-3 col-sm-3">
            <button type="button" class="btn btn-primary radius-0 font-13" (click)="submitAssetData()">Submit</button>
        </div>
        <!--    <div class="col-md-3 col-sm-3">-->
        <!--      <ol class="breadcrumb cust-bread">-->
        <!--        <li class="breadcrumb-item"><a class="pointer" (click)="changeRouting('dashboard')"><i-->
        <!--          class="fa fa-dashboard"></i> Home</a></li>-->
        <!--        <li class="breadcrumb-item active" aria-current="page">Asset Maintain</li>-->
        <!--      </ol>-->
        <!--    </div>-->
    </div>
    <div class="row content mr-top-5 mar-lft-rgt-0">
        <div class="container">
            <div class="row" *ngIf="columnValueObj.length > 0">
                <div class="offset-4 col-sm-2">
                    <button class="btn btn-success btn-block radius-0 font-13" (click)="editAssetRecord(recordId)">Update</button>
                </div>
                <div class="col-sm-2">
                    <button class="btn btn-warning btn-block radius-0 font-13" (click)="deleteAssetRecord(recordId)">Delete
                    </button>
                </div>
            </div>
        </div>
        <div class="offset-3 col-sm-6 mar-top-15">
            <div [hidden]="dataLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif"></div>
            <table class="table  mar-left-rgt-15">
                <thead>
                <!--<tr>-->
                <!--<th>Column</th>-->
                <!--<th>Value</th>-->
                <!--</tr>-->
                </thead>
                <tbody id="tbody">
                    <tr *ngFor="let column of columnValueObj">
                        <td>{{column.columnName}}</td>
                        <td *ngIf="column.validationValue;else select_content">
                            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="column.assetValue">
                                <option *ngFor="let validation of column.validationValue"
                                        [value]="validation">{{validation}}</option>
                            </select>
                        </td>
                        <ng-template #select_content>
                            <td *ngIf="column.columnName === 'Asset ID';else input_content">
                                <input type="text" class="form-control radius-0 font-13" [readonly]="true"
                                       [(ngModel)]="column.assetValue"
                                       placeholder="{{column.columnName}}">
                            </td>
                            <ng-template #input_content>
                                <td>
                                    <input type="text" class="form-control radius-0 font-13" [(ngModel)]="column.assetValue"
                                           placeholder="{{column.columnName}}">
                                </td>
                            </ng-template>
                        </ng-template>
                    </tr>
                </tbody>

            </table>
        </div>
    </div>
    <!--<div class="form-group row">-->
    <!--<div class="col-md-9">-->
    <!--<input type="text" class="form-control radius-0 font-13" [(ngModel)]="assetValue"-->
    <!--placeholder="Digital Asset Id">-->
    <!--</div>-->
    <!--<div class="col-md-3">-->
    <!--<button type="button" class="btn btn-primary radius-0 font-13" (click)="submitAssetData()">Submit</button>-->
    <!--</div>-->
    <!--</div>-->
</div>

<!--<div class="container">-->
<!--<table class="table table-bordered">-->
<!--<thead>-->
<!--<tr>-->
<!--<th>Column</th>-->
<!--<th>Value</th>-->
<!--</tr>-->
<!--</thead>-->
<!--<tbody id="tbody">-->
<!--</tbody>-->
<!--</table>-->
<!--</div>-->
<notifier-container></notifier-container>
